import axios from "@/api/interceptor";
import axiosSso from "@/api/interceptor_sso";

// 登录
export function login(data: any) {
  return axiosSso.post("/common/users/login", data);
}

// 修改密码
export function putUpdatePwd(data: any) {
  return axios.put("/update-password", data);
}

// 获取logo
export function getLogo(params: any) {
  return axios.get("/user/tools/web-config", { params });
}

// 直客免密登录
export function postRestsClientLogin(data: any) {
  return axios.post("/user/rests/client-safe-login", data);
}

// 可选抖音套餐
export function getUserRestsClientVersion(params: any) {
  return axios.get("/user/rests/client/version", { params });
}

// 用户信息
export function getUserProfilesUserInfo(params?: any) {
  return axios.get("/user/profiles/user-info", { params });
}

// 免密登录
export function postSafeLogin(data: any) {
  return axiosSso.post("/common/users/safe-login", data);
}

// 环境配置
export function getUserSetting(params?: any) {
  return axiosSso.get("/common/users/setting", { params });
}

// 二代列表
export function getUsersAgent2(params?: any) {
  return axiosSso.get("/common/users/agent2", { params });
}

// 直客列表
export function getUsersClient(params?: any) {
  return axiosSso.get("/common/users/client", { params });
}

// 设置产品
export function putUsersProduct(data: any) {
  return axiosSso.put("/common/users/product", data);
}
